(function () {

  'use strict';



  /* ============================================================

     GM WATCHES — COLLECTION PRODUCT GRID

     External JS — النسخة المُعدّلة

     ============================================================

     الإصلاحات:

     - استخدام data-attributes بدل IDs (دعم multiple instances)

     - تحويل NodeList لـ Array قبل forEach (توافق أوسع)

     - تحديث data-next-url مع absolute URLs

     - إصلاح شريط التقدم بعد Load More

     - إصلاح إزالة رسائل الخطأ

     - ✅ إصلاح فلتر السعر (تحويل من جنيهات لقروش عند الإرسال)

     - ✅ حماية الـ inputs من القيم الغريبة

     ============================================================ */



  var GMCollectionGrid = window.GMCollectionGrid || {};

  window.GMCollectionGrid = GMCollectionGrid;



  GMCollectionGrid.instances = GMCollectionGrid.instances || {};



  function qs(selector, scope) {

    return (scope || document).querySelector(selector);

  }



  function qsa(selector, scope) {

    return Array.prototype.slice.call(

      (scope || document).querySelectorAll(selector)

    );

  }



  function getSectionRoot() {

    return qs('[data-gm-section="collection"].gm-cgrid');

  }



  function getSectionId(root) {

    if (!root) return '';

    var id = root.getAttribute('id') || '';

    return id.replace(/^gm-collection-grid-/, '');

  }



  function getToolbar(root) {

    return qs('[data-gm-toolbar]', root);

  }



  function getCurrentUrl() {

    return new URL(window.location.href);

  }



  function setBodyLock(state) {

    document.documentElement.classList.toggle('gm-filter-open', !!state);

    if (document.body) {

      document.body.classList.toggle('gm-filter-open', !!state);

    }

  }



  function setSectionLoading(root, state) {

    if (!root) return;

    root.classList.toggle('gm-cgrid__section-loading', !!state);

    root.setAttribute('aria-busy', state ? 'true' : 'false');

  }



  function openFilter(root) {

    var drawer = qs('[data-gm-filter-drawer]', root);

    var overlay = qs('[data-gm-filter-overlay]', root);

    var button = qs('[data-gm-filter-open]', root);



    if (!drawer) return;



    drawer.classList.add('is-open');

    drawer.setAttribute('aria-hidden', 'false');



    if (overlay) overlay.classList.add('is-visible');

    if (button) button.setAttribute('aria-expanded', 'true');



    setBodyLock(true);

  }



  function closeFilter(root) {

    var drawer = qs('[data-gm-filter-drawer]', root);

    var overlay = qs('[data-gm-filter-overlay]', root);

    var button = qs('[data-gm-filter-open]', root);



    if (!drawer) return;



    drawer.classList.remove('is-open');

    drawer.setAttribute('aria-hidden', 'true');



    if (overlay) overlay.classList.remove('is-visible');

    if (button) button.setAttribute('aria-expanded', 'false');



    setBodyLock(false);

  }



  function openSort(root) {

    var drawer = qs('[data-gm-sort-drawer]', root);

    var overlay = qs('[data-gm-sort-overlay]', root);

    var button = qs('[data-gm-sort-open]', root);



    if (!drawer) return;



    drawer.classList.add('is-open');

    drawer.setAttribute('aria-hidden', 'false');



    if (overlay) overlay.classList.add('is-visible');

    if (button) button.setAttribute('aria-expanded', 'true');



    setBodyLock(true);

  }



  function closeSort(root) {

    var drawer = qs('[data-gm-sort-drawer]', root);

    var overlay = qs('[data-gm-sort-overlay]', root);

    var button = qs('[data-gm-sort-open]', root);



    if (!drawer) return;



    drawer.classList.remove('is-open');

    drawer.setAttribute('aria-hidden', 'true');



    if (overlay) overlay.classList.remove('is-visible');

    if (button) button.setAttribute('aria-expanded', 'false');



    setBodyLock(false);

  }



  function countActiveFilters(root) {

    var form = qs('[data-gm-filter-form]', root);

    if (!form) return 0;



    var count = 0;



    qsa('input[type="checkbox"]:checked', form).forEach(function () {

      count += 1;

    });



    qsa('input[type="number"]', form).forEach(function (input) {

      if (String(input.value || '').trim() !== '') count += 1;

    });



    return count;

  }



  function updateFilterCount(root) {

    var badge = qs('[data-gm-filter-count]', root);

    if (!badge) return;



    var count = countActiveFilters(root);



    if (count > 0) {

      badge.hidden = false;

      badge.textContent = String(count);

    } else {

      badge.hidden = true;

      badge.textContent = '0';

    }

  }



  /* ✅ تنظيف inputs السعر من أي قيم غريبة */

  function sanitizePriceInputs(root) {

    qsa('[data-gm-price-input]', root).forEach(function (input) {

      if (input.dataset.gmSanitized === 'true') return;

      input.dataset.gmSanitized = 'true';



      input.addEventListener('input', function () {

        // إزالة أي حاجة غير الأرقام

        var raw = this.value.replace(/[^\d]/g, '');



        // لو القيمة أكبر من 8 أرقام، نقصها

        if (raw.length > 8) {

          raw = raw.slice(0, 8);

        }



        if (this.value !== raw) {

          this.value = raw;

        }

      });



      input.addEventListener('blur', function () {

        var value = parseFloat(this.value);



        if (isNaN(value) || value < 0) {

          this.value = '';

          return;

        }



        // نضمن إن القيمة رقم صحيح

        this.value = String(Math.floor(value));

      });

    });

  }



  /* ✅ التحقق لو الـ field ده خاص بالسعر */

  function isPriceField(key) {

    if (!key) return false;



    // Shopify price filter parameters. Values are sent in the shop's

    // default currency (for example 6 or 10), not in cents.

    return (

      key === 'filter.v.price.gte' ||

      key === 'filter.v.price.lte'

    );

  }



  function buildRequestUrl(root, form) {

    var toolbar = getToolbar(root);

    var collectionUrl = toolbar

      ? toolbar.getAttribute('data-collection-url')

      : window.location.pathname;



    var url = new URL(collectionUrl || window.location.pathname, window.location.origin);

    var current = getCurrentUrl();



    current.searchParams.forEach(function (value, key) {

      if (

        key !== 'page' &&

        key !== 'sort_by' &&

        key.indexOf('filter.') !== 0

      ) {

        url.searchParams.append(key, value);

      }

    });



    Array.from(url.searchParams.keys()).forEach(function (key) {

      if (key === 'page' || key === 'sort_by' || key.indexOf('filter.') === 0) {

        url.searchParams.delete(key);

      }

    });



    if (form) {

      var formData = new FormData(form);



      formData.forEach(function (value, key) {

        if (value === null || value === undefined) return;



        var cleanValue = String(value).trim();



        if (!cleanValue) return;



        // Shopify expects price filter values in the shop's default currency.

        // Keep the user's value unchanged (6 stays 6, 10 stays 10).

        if (isPriceField(key)) {

          var numericValue = Number(cleanValue);



          if (!Number.isFinite(numericValue) || numericValue < 0) {

            return;

          }



          cleanValue = String(numericValue);

        }



        url.searchParams.append(key, cleanValue);

      });

    }



    var sortSelect = qs('[data-gm-sort]', root);

    if (sortSelect && sortSelect.value) {

      url.searchParams.set('sort_by', sortSelect.value);

    }



    url.searchParams.delete('page');



    return url;

  }



  function getSectionRequestUrl(url, sectionId) {

    var requestUrl = new URL(url.toString());

    requestUrl.searchParams.set('section_id', sectionId);

    return requestUrl;

  }



  function updateBrowserUrl(url, replace) {

    var cleanUrl = new URL(url.toString());

    cleanUrl.searchParams.delete('section_id');

    cleanUrl.searchParams.delete('page');



    if (replace) {

      window.history.replaceState({ gmCollection: true }, '', cleanUrl.toString());

    } else {

      window.history.pushState({ gmCollection: true }, '', cleanUrl.toString());

    }

  }



  function getRenderedSection(html, sectionId) {

    var parser = new DOMParser();

    var doc = parser.parseFromString(html, 'text/html');



    return (

      doc.getElementById('gm-collection-grid-' + sectionId) ||

      doc.querySelector('[data-gm-section="collection"].gm-cgrid')

    );

  }



  function replaceSection(root, newSection) {
    if (!root || !newSection || !root.parentNode) return null;

    var parent = root.parentNode;
    var replacement = document.importNode(newSection, true);

    /* Preserve the viewport position while Shopify replaces the section. */
    var scrollX = window.scrollX || window.pageXOffset || 0;
    var scrollY = window.scrollY || window.pageYOffset || 0;

    parent.replaceChild(replacement, root);

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        if (window.scrollTo) {
          window.scrollTo(scrollX, scrollY);
        }
      });
    } else if (window.scrollTo) {
      window.scrollTo(scrollX, scrollY);
    }

    return replacement;
  }



  function showRequestError(root, message) {

    if (!root) return;



    var existing = qs('[data-gm-request-error]', root);



    if (!existing) {

      existing = document.createElement('div');

      existing.setAttribute('data-gm-request-error', 'true');

      existing.style.cssText =

        'margin:12px 0;padding:12px 14px;border:1px solid #e3e3e3;border-radius:10px;background:#fff;color:#555;text-align:center;font:600 13px/1.7 Cairo,Arial,sans-serif;';



      var toolbar = qs('[data-gm-toolbar]', root);

      if (toolbar && toolbar.parentNode) {

        toolbar.parentNode.insertBefore(existing, toolbar.nextSibling);

      }

    }



    existing.textContent = message || 'تعذر تحديث المنتجات. حاول مرة أخرى.';

  }



  function clearRequestError(root) {

    var existing = qs('[data-gm-request-error]', root);

    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

  }



  function fetchAndRender(root, requestUrl, options) {

    options = options || {};



    var sectionId = getSectionId(root);

    if (!sectionId) return Promise.reject(new Error('Missing section ID'));



    var controller = GMCollectionGrid.instances[sectionId];



    if (controller && controller.abortController) {

      controller.abortController.abort();

    }



    /* Cancel any previous request for this section before starting a new one.

       This prevents rapid filter/sort changes from wasting bandwidth and CPU. */

    var previousInstance = GMCollectionGrid.instances[sectionId];

    if (previousInstance && previousInstance.abortController) {

      try { previousInstance.abortController.abort(); } catch (e) {}

    }



    var abortController =

      typeof AbortController !== 'undefined'

        ? new AbortController()

        : null;



    GMCollectionGrid.instances[sectionId] = {

      abortController: abortController

    };



    var sectionRequestUrl = getSectionRequestUrl(requestUrl, sectionId);



    setSectionLoading(root, true);

    clearRequestError(root);



    var fetchOptions = {

      method: 'GET',

      credentials: 'same-origin',

      headers: {

        'X-Requested-With': 'XMLHttpRequest',

        Accept: 'text/html'

      }

    };



    if (abortController) {

      fetchOptions.signal = abortController.signal;

    }



    return fetch(sectionRequestUrl.toString(), fetchOptions)

      .then(function (response) {

        if (!response.ok) {

          throw new Error('Collection section request failed: ' + response.status);

        }



        return response.text();

      })

      .then(function (html) {

        var newSection = getRenderedSection(html, sectionId);



        if (!newSection) {

          throw new Error('Updated collection section was not found');

        }



        var newRoot = replaceSection(root, newSection);



        if (!newRoot) {

          throw new Error('Unable to replace collection section');

        }



        updateBrowserUrl(requestUrl, !!options.replaceHistory);



        clearRequestError(newRoot);

        GMCollectionGrid.init(newRoot);

        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function () {
            setSectionLoading(newRoot, false);
          });
        } else {
          setSectionLoading(newRoot, false);
        }

        return newRoot;

      })

      .catch(function (error) {

        if (error && error.name === 'AbortError') {

          return null;

        }



        console.error('GM WATCHES — Collection update error:', error);

        setSectionLoading(root, false);

        showRequestError(

          root,

          'تعذر تحديث المنتجات عبر الاتصال السريع. تم الحفاظ على المنتجات الحالية.'

        );



        return null;

      });

  }



  function initFilteringAndSorting(root) {

    var toolbar = getToolbar(root);

    if (!toolbar) return;



    var form = qs('[data-gm-filter-form]', root);

    var openButton = qs('[data-gm-filter-open]', root);

    var closeButton = qs('[data-gm-filter-close]', root);

    var overlay = qs('[data-gm-filter-overlay]', root);

    var resetButton = qs('[data-gm-filter-reset]', root);



    var sortOpenButton = qs('[data-gm-sort-open]', root);

    var sortCloseButton = qs('[data-gm-sort-close]', root);

    var sortOverlay = qs('[data-gm-sort-overlay]', root);

    var sortOptions = qsa('[data-gm-sort-option]', root);



    if (openButton && openButton.dataset.gmBound !== 'true') {

      openButton.dataset.gmBound = 'true';

      openButton.addEventListener('click', function () {

        closeSort(root);

        openFilter(root);

      });

    }



    if (closeButton && closeButton.dataset.gmBound !== 'true') {

      closeButton.dataset.gmBound = 'true';

      closeButton.addEventListener('click', function () {

        closeFilter(root);

      });

    }



    if (overlay && overlay.dataset.gmBound !== 'true') {

      overlay.dataset.gmBound = 'true';

      overlay.addEventListener('click', function () {

        closeFilter(root);

      });

    }



    if (sortOpenButton && sortOpenButton.dataset.gmBound !== 'true') {

      sortOpenButton.dataset.gmBound = 'true';

      sortOpenButton.addEventListener('click', function () {

        closeFilter(root);

        openSort(root);

      });

    }



    if (sortCloseButton && sortCloseButton.dataset.gmBound !== 'true') {

      sortCloseButton.dataset.gmBound = 'true';

      sortCloseButton.addEventListener('click', function () {

        closeSort(root);

      });

    }



    if (sortOverlay && sortOverlay.dataset.gmBound !== 'true') {

      sortOverlay.dataset.gmBound = 'true';

      sortOverlay.addEventListener('click', function () {

        closeSort(root);

      });

    }



    sortOptions.forEach(function (option) {

      if (option.dataset.gmBound === 'true') return;



      option.dataset.gmBound = 'true';



      option.addEventListener('click', function () {

        var sortValue = option.getAttribute('data-gm-sort-option');

        if (!sortValue) return;



        var requestUrl = buildRequestUrl(root, form);

        requestUrl.searchParams.set('sort_by', sortValue);



        closeSort(root);



        fetchAndRender(root, requestUrl, {

          replaceHistory: false

        });

      });

    });



    if (form && form.dataset.gmBound !== 'true') {

      form.dataset.gmBound = 'true';



      form.addEventListener('submit', function (event) {

        event.preventDefault();



        var requestUrl = buildRequestUrl(root, form);



        closeFilter(root);



        fetchAndRender(root, requestUrl, {

          replaceHistory: false

        });

      });



      form.addEventListener('change', function () {

        updateFilterCount(root);

      });

    }



    if (resetButton && resetButton.dataset.gmBound !== 'true') {

      resetButton.dataset.gmBound = 'true';



      resetButton.addEventListener('click', function () {

        if (form) {

          qsa('input[type="checkbox"]', form).forEach(function (input) {

            input.checked = false;

          });



          qsa('input[type="number"]', form).forEach(function (input) {

            input.value = '';

          });

        }



        updateFilterCount(root);



        var requestUrl = buildRequestUrl(root, form);

        closeFilter(root);



        fetchAndRender(root, requestUrl, {

          replaceHistory: false

        });

      });

    }



    updateFilterCount(root);

  }



  function initLoadMore(root) {

    var loadMoreBtn = qs('[data-gm-load-more-btn]', root);

    var gridContainer = qs('[data-gm-product-grid]', root);

    var loadMoreWrap = qs('[data-gm-load-more-wrap]', root);

    var loadedCountSpan = qs('[data-gm-loaded-count]', root);



    if (!loadMoreBtn || !gridContainer) return;



    if (loadMoreBtn.dataset.gmInitialized === 'true') return;

    loadMoreBtn.dataset.gmInitialized = 'true';



    var isLoading = false;



    function setLoading(state) {

      isLoading = state;

      loadMoreBtn.disabled = state;



      var btnText = loadMoreBtn.querySelector('span:not(.gm-load-spinner)');

      var spinner = loadMoreBtn.querySelector('.gm-load-spinner');



      if (btnText) btnText.style.display = state ? 'none' : 'inline-block';

      if (spinner) spinner.style.display = state ? 'inline-block' : 'none';

    }



    function hideLoadMore() {

      if (!loadMoreWrap) return;



      loadMoreWrap.style.opacity = '0';



      setTimeout(function () {

        if (loadMoreWrap && loadMoreWrap.parentNode) {

          loadMoreWrap.remove();

        }

      }, 300);

    }



    function updateLoadedCount() {

      var currentCardsCount =

        gridContainer.querySelectorAll('.gm-product-card').length;



      if (loadedCountSpan) {

        loadedCountSpan.textContent = currentCardsCount;

      }



      /* تحديث شريط التقدم */

      var progressFill = qs('.gm-cgrid__progress-fill', root);

      var progressBar = qs('.gm-cgrid__progress-bar', root);

      var totalCountSpan = qs('[data-gm-total-count]', root);



      if (progressFill && progressBar && totalCountSpan) {

        var total = parseInt(totalCountSpan.textContent, 10) || 0;



        if (total > 0) {

          var percent = Math.min(

            100,

            Math.round((currentCardsCount / total) * 100)

          );



          progressFill.style.width = percent + '%';

          progressBar.setAttribute('aria-valuenow', percent);

        }

      }



      return currentCardsCount;

    }



    loadMoreBtn.addEventListener('click', function (event) {

      event.preventDefault();



      if (isLoading) return;



      var nextUrl = loadMoreBtn.getAttribute('data-next-url');



      if (!nextUrl) {

        hideLoadMore();

        return;

      }



      setLoading(true);



      fetch(nextUrl, {

        method: 'GET',

        credentials: 'same-origin',

        headers: {

          'X-Requested-With': 'XMLHttpRequest',

          Accept: 'text/html'

        }

      })

        .then(function (response) {

          if (!response.ok) {

            throw new Error(

              'Failed to load collection products: ' + response.status

            );

          }



          return response.text();

        })

        .then(function (html) {

          var parser = new DOMParser();

          var doc = parser.parseFromString(html, 'text/html');



          var newGridItems = Array.prototype.slice.call(

            doc.querySelectorAll(

              '[data-gm-product-grid] .gm-product-card'

            )

          );



          var nextBtnNew = doc.querySelector('[data-gm-load-more-btn]');



          if (!newGridItems.length && !nextBtnNew) {

            throw new Error(

              'No collection products or pagination data found'

            );

          }



          newGridItems.forEach(function (item) {

            gridContainer.appendChild(document.importNode(item, true));

          });



          updateLoadedCount();



          if (nextBtnNew) {

            var newUrl = nextBtnNew.getAttribute('data-next-url');



            if (newUrl) {

              /* تحويل الـ URL لـ absolute قبل تخزينه */

              var absoluteUrl = new URL(newUrl, window.location.origin).toString();

              loadMoreBtn.setAttribute('data-next-url', absoluteUrl);

              setLoading(false);

              return;

            }

          }



          hideLoadMore();

          setLoading(false);

        })

        .catch(function (error) {

          console.error('GM WATCHES — Load More error:', error);

          setLoading(false);

          showRequestError(

            root,

            'تعذر تحميل المزيد من المنتجات. يمكنك المحاولة مرة أخرى.'

          );

        });

    });

  }



  function init(root) {

    root = root || getSectionRoot();



    if (!root) return;



    initFilteringAndSorting(root);

    initLoadMore(root);

    sanitizePriceInputs(root); // ✅ حماية inputs السعر

  }



  GMCollectionGrid.init = init;



  function handlePopState() {

    var root = getSectionRoot();



    if (!root) {

      window.location.reload();

      return;

    }



    closeFilter(root);



    var currentUrl = getCurrentUrl();



    fetchAndRender(root, currentUrl, {

      replaceHistory: true

    });

  }



  function boot() {

    if (document.readyState === 'loading') {

      document.addEventListener(

        'DOMContentLoaded',

        function () {

          GMCollectionGrid.init();

        },

        { once: true }

      );

    } else {

      GMCollectionGrid.init();

    }



    if (window.GMCollectionGridPopStateBound !== true) {

      window.GMCollectionGridPopStateBound = true;

      window.addEventListener('popstate', handlePopState);

    }



    if (window.GMCollectionGridEscapeBound !== true) {

      window.GMCollectionGridEscapeBound = true;



      document.addEventListener('keydown', function (event) {

        if (event.key !== 'Escape') return;



        var root = getSectionRoot();

        if (!root) return;



        var drawer = qs('[data-gm-filter-drawer]', root);

        if (drawer && drawer.classList.contains('is-open')) {

          closeFilter(root);

          return;

        }



        var sortDrawer = qs('[data-gm-sort-drawer]', root);

        if (sortDrawer && sortDrawer.classList.contains('is-open')) {

          closeSort(root);

        }

      });

    }

  }



  boot();

})();